module.exports = __webpack_public_path__ + "static/img/tourimg-3.df010be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/tourimg-3.png
// module id = ZD3R
// module chunks = 1